import { Apple, ArrowRight, CheckCircle2, Download, ShieldCheck, Smartphone } from 'lucide-react';
import { BrandLogo } from '../components';
import { MOBILE_APP_STORES } from '../mobile-store-links';

export function InstallPage() {
  const params = new URLSearchParams(window.location.search);
  const platform = params.get('platform');
  return <main className="install-page">
    <nav className="install-nav"><BrandLogo surface="light" /><a href="mailto:hello@wormos.com">Need help?</a></nav>
    <section className="install-hero">
      <div className="install-hero__visual"><span><Smartphone size={52} /></span><i /><i /><i /></div>
      <div className="install-hero__copy"><span className="install-kicker"><Download size={14} />Nosivo mobile workspace</span>
        <h1>Install Nosivo for the best mobile experience.</h1>
        <p>Attendance, notifications and your daily work tools are designed to run securely in the Nosivo app on Android and iOS.</p>
        <div className="install-actions">
          <a className={platform === 'android' ? 'is-recommended' : ''} href={MOBILE_APP_STORES.android}><span><Smartphone size={22} /><small>Get it on</small><strong>Google Play</strong></span><ArrowRight size={17} /></a>
          <a className={platform === 'ios' ? 'is-recommended' : ''} href={MOBILE_APP_STORES.ios}><span><Apple size={23} /><small>Download on the</small><strong>App Store</strong></span><ArrowRight size={17} /></a>
        </div>
        <div className="install-trust"><span><ShieldCheck size={16} />Company workspace sign-in</span><span><CheckCircle2 size={16} />Face attendance ready</span></div>
      </div>
    </section>
    <footer>Nosivo by Wormos · Secure workforce operations</footer>
  </main>;
}

